import React from 'react';
import { Phone, MapPin, Clock, Navigation, ExternalLink } from 'lucide-react';
import { BUSINESS } from '../config';

export default function Contact() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16" data-testid="contact-page">
      <div className="text-center mb-12">
        <h1 className="font-heading font-heading text-3xl md:text-4xl uppercase tracking-tight text-primary mb-3">Contact & Accès</h1>
        <p className="text-slate-600 max-w-lg mx-auto">Besoin d'un renseignement ? Appelez-nous ou passez directement en boutique.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Info */}
        <div className="space-y-6">
          {/* Phone (big) */}
          <a
            href={`tel:${BUSINESS.telephoneRaw}`}
            className="block bg-secondary/10 border border-secondary/30 rounded-sm p-6 hover:bg-secondary/15 transition-colors group"
            data-testid="contact-phone"
          >
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-sm bg-secondary flex items-center justify-center group-hover:shadow-lg transition-shadow">
                <Phone className="w-7 h-7 text-black" />
              </div>
              <div>
                <p className="text-sm text-secondary mb-0.5">Appelez-nous</p>
                <p className="font-heading font-heading text-2xl md:text-3xl uppercase tracking-tight text-primary">{BUSINESS.telephone}</p>
              </div>
            </div>
          </a>

          {/* Address */}
          <div className="bg-white rounded-sm border border-slate-200 p-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-sm bg-white/5 flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-secondary" />
              </div>
              <div>
                <p className="text-xs text-slate-600 mb-0.5">Adresse</p>
                <p className="text-primary font-medium mb-2">{BUSINESS.adresse}</p>
                <a
                  href={BUSINESS.urlGoogleMaps}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm text-secondary hover:text-secondary"
                >
                  <Navigation className="w-3.5 h-3.5" />
                  Itinéraire Google Maps
                  <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div className="bg-white rounded-sm border border-slate-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <Clock className="w-5 h-5 text-secondary" />
              <h3 className="font-heading font-semibold text-primary uppercase tracking-wider">Horaires d'ouverture</h3>
            </div>
            <div className="space-y-2.5">
              {Object.entries(BUSINESS.horaires).map(([day, hours]) => (
                <div key={day} className="flex justify-between items-center">
                  <span className="text-sm text-slate-600">{day}</span>
                  <span className={`text-sm font-medium {hours === 'Fermé' ? 'text-rose-600' : 'text-white'}`} data-testid={`contact-horaires-${day}`}>
                    {hours}
                    {BUSINESS.horairesLiens?.[day] && (
                      <>
                        {' — '}
                        <a
                          href={BUSINESS.horairesLiens[day].url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-secondary hover:underline"
                        >
                          {BUSINESS.horairesLiens[day].texte}
                        </a>
                      </>
                    )}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-4 pt-4 border-t border-slate-200">
              <p className="text-sm text-secondary font-medium">Retrait matériel : {BUSINESS.creneauRetrait}</p>
              <p className="text-xs text-slate-500 mt-1">Créneau dédié au retrait et à la remise du matériel</p>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="space-y-4">
          <div className="rounded-sm overflow-hidden border border-slate-200 aspect-square lg:aspect-auto lg:h-full min-h-[400px]">
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(BUSINESS.adresse)}&zoom=15`}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Carte Informatique Meaux"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
